"use client";
import React, { useEffect, useState } from "react";
import LoginScreen from "src/comps/LoginScreen";
import { UserContext } from "src/contexts/UserContext";

export default function Debugatron3000() {
  const { user } = React.useContext(UserContext);
  const [loading, setLoading] = useState(true);

  // console.log({ user });

  useEffect(() => {
    setLoading(false)
  }, [])


  if (!loading) return <LoginScreen />;
}
